import { render, staticRenderFns } from "./SwitchOrgDialog.vue?vue&type=template&id=3e4e4e5e&scoped=true&"
import script from "./SwitchOrgDialog.vue?vue&type=script&lang=js&"
export * from "./SwitchOrgDialog.vue?vue&type=script&lang=js&"
import style0 from "./SwitchOrgDialog.vue?vue&type=style&index=0&id=3e4e4e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4e4e5e",
  null
  
)

export default component.exports